import { isEmpty, isNil } from 'ramda';

export default function isNilOrEmpty(value: any): boolean {
  return isNil(value) || isEmpty(value);
}